// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ScriptCache.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// We dont have callback query on loading GG Maps API Url

const window =
  (typeof self === 'object' && self.self === self && self) ||
  (typeof global === 'object' && global.global === global && global) ||
  this;
let scriptMap = (typeof window !== 'undefined' && window.izScriptMap) || new Map();

export const ScriptCache = (function(context) {
  context.izScriptMap = context.izScriptMap || scriptMap;

  return function ScriptCache(host, scripts) {
    const Cache = {};
    const { document: doc } = host;

    Cache._onLoad = key => {
      return callback => {
        let registered = true;

        function unregister() {
          registered = false;
        }

        let stored = scriptMap.get(key);

        if (stored) {
          stored.promise.then(() => {
            if (registered) {
              stored.error ? callback(stored.error) : callback(null, stored);
            }

            return stored;
          });
        }

        return unregister;
      };
    };

    Cache._scriptTag = (key, src) => {
      if (!scriptMap.has(key)) {
        if (typeof doc === 'undefined') return null;

        let tag = doc.createElement('script');
        let promise = new Promise((resolve, reject) => {
          let body = doc.querySelector('body');
          tag.type = 'text/javascript';
          tag.async = false;

          let handleResult = state => evt => {
            let stored = scriptMap.get(key);
            if (state === 'loaded') {
              stored.resolved = true;
              resolve(src);
            } else if (state === 'error') {
              stored.errored = true;
              reject(evt);
            }
            stored.loaded = true;
          };

          tag.onload = handleResult('loaded');
          tag.onerror = handleResult('error');
          tag.onreadystatechange = () => {
            handleResult(tag.readyState);
          };

          tag.addEventListener('load', tag.onload);
          tag.addEventListener('error', tag.onerror);

          tag.src = src;
          body.appendChild(tag); // start load script from here.

          return tag;
        });
        let initialState = {
          time: new Date(),
          loaded: false,
          error: false,
          promise: promise,
          tag
        };
        scriptMap.set(key, initialState);
      }
      return scriptMap.get(key);
    };

    Object.keys(scripts).forEach(key => {
      const script = scripts[key];

      const tag = context.izScriptMap.has(key) ? context.izScriptMap.get(key).tag : Cache._scriptTag(key, script);

      Cache[key] = {
        tag: tag,
        onLoad: Cache._onLoad(key)
      };
    });

    return Cache;
  };
})(window);

export default ScriptCache;



// WEBPACK FOOTER //
// ./ui/share/components/charting/googlemaps/google_api_loader/Izenda.ScriptCache.js